import { colors } from '../../colors';
var service = {
  bgColor: colors.white,
  borderColor: colors.overcast,
  bgColorBlade: colors.white,
  carouselDotColor: colors.neonPurple,
  linkColor: colors.neonPurple,
  cardRadius: '20px',
  textColorDark: colors.slateGrey,
  textColorLight: colors.white
};
export default service;